var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.74402V17.324C2 18.1197 2.31607 18.8827 2.87868 19.4453C3.44129 20.0079 4.20435 20.324 5 20.324H20C20.7956 20.324 21.5587 20.0079 22.1213 19.4453C22.6839 18.8827 23 18.1197 23 17.324V8.74402L14.072 14.237C13.5992 14.5279 13.0551 14.6819 12.5 14.6819C11.9449 14.6819 11.4008 14.5279 10.928 14.237L2 8.74402Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.98197V6.82397C23 6.02833 22.6839 5.26526 22.1213 4.70265C21.5587 4.14005 20.7956 3.82397 20 3.82397H5C4.20435 3.82397 3.44129 4.14005 2.87868 4.70265C2.31607 5.26526 2 6.02833 2 6.82397V6.98197L11.714 12.96C11.9504 13.1054 12.2225 13.1824 12.5 13.1824C12.7775 13.1824 13.0496 13.1054 13.286 12.96L23 6.98197Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.a628c341b633a7b7a3ec9799a632d1ce.svg";
export { ForwardRef as ReactComponent };